import React, { useEffect, useState } from "react"
import {
  Box,
  Typography,
  Button,
  Chip,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  CircularProgress,
} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import { useApiService } from "../hooks/Api/useApiService"
import DeleteIcon from "@mui/icons-material/Delete"

const HobbiesSection = ({ user_name }) => {
  const [hobbies, setHobbies] = useState([])
  const [loading, setLoading] = useState(true)
  const [openDialog, setOpenDialog] = useState(false)
  const [newHobby, setNewHobby] = useState("")
  const { postData } = useApiService()

  useEffect(() => {
    postData("sharie/gethobbies", { user_name: user_name })
      .then((data) => {
        setHobbies(data.hobbies || [])
        setLoading(false)
      })
      .catch((err) => {
        console.error("Failed to fetch hobbies", err)
        setLoading(false)
      })
  }, [])

  const handleDeleteHobby = (hobbyToDelete) => {
    postData("sharie/deletehobby", {
      hobby: hobbyToDelete.hobby,
      user_name: localStorage.getItem("user"),
    })
      .then(() => {
        setHobbies((prev) => prev.filter((hobby) => hobby !== hobbyToDelete))
      })
      .catch((err) => {
        console.error("Failed to delete hobby", err)
      })
  }

  const handleAddHobby = () => {
    if (!newHobby.trim()) return

    postData("sharie/addhobby", { hobby: newHobby, user_name: localStorage.getItem("user") })
      .then((data) => {
        setHobbies((prev) => [...prev, newHobby])
        setNewHobby("")
        setOpenDialog(false)
      })
      .catch((err) => {
        console.error("Failed to add hobby", err)
      })
  }

  return (
    <Box sx={{ p: 2, bgcolor: "background.paper", borderRadius: 2, width: "100%" }}>
      <Typography variant='h6' color='primary' mb={2}>
        תחביבים
      </Typography>

      {loading ? (
        <CircularProgress color='secondary' />
      ) : hobbies.length === 0 ? (
        <Typography color='text.secondary' mb={2}>
          עדיין לא הוספת תחביבים
        </Typography>
      ) : (
        <Stack direction='row' spacing={1} flexWrap='wrap' mb={2}>
          {hobbies.map((hobby, index) => (
            <Chip
              onDelete={() =>
                localStorage.getItem("user") === user_name ? handleDeleteHobby(hobby) : {}
              }
              deleteIcon={
                localStorage.getItem("user") === user_name ? (
                  <DeleteIcon style={{ color: "GrayText", marginInlineEnd: "3px" }} />
                ) : null
              }
              key={index}
              label={hobby.hobby}
              color='secondary'
              variant='outlined'
              sx={{ margin: "3px" }}
            />
          ))}
        </Stack>
      )}

      {localStorage.getItem("user") === user_name && (
        <Button
          variant='contained'
          color='primary'
          startIcon={<AddIcon style={{ marginInlineEnd: "3px" }} />}
          onClick={() => setOpenDialog(true)}
        >
          הוסף תחביב
        </Button>
      )}

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle color='primary'>הוסף תחביב חדש</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label='תחביב'
            value={newHobby}
            onChange={(e) => setNewHobby(e.target.value)}
            color='secondary'
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color='secondary'>
            ביטול
          </Button>
          <Button onClick={handleAddHobby} color='primary' variant='contained'>
            שמירה
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default HobbiesSection
